import { useCallback } from "react";
import { useAPIAction, ViewerLinkApi } from "melco-shared-logic";

export const useDeleteViewerLink = () => {
  const [deleteViewerLink] = useAPIAction(
    ViewerLinkApi,
    async (api: ViewerLinkApi, id: string) => {
      const data = await api.statisticalViewerLinkDelete({ id });

      return {
        successMessages: [{ message: "default" }],
        data,
      };
    },
    {
      translationPrefix: "reporting.machinestatus.view.viewerlink.actions.delete",
    }
  );

  return useCallback(
    async (viewId: string) => {
      const successfullyDeleted: string[] = [];

      // for (const ViewerLinkId of ViewerLinkIds) {
      try {
        await deleteViewerLink(viewId);
        successfullyDeleted.push(viewId);
      } catch (e) {
        // error handling is already done in useAPIAction
      }
      //}

      return successfullyDeleted;
    },
    [deleteViewerLink]
  );
};
